import { h, Fragment } from 'preact';
import { OPTION, OPTION_DATA } from '../utils/product';
import ShopOptionInput from './ShopOptionInput';

const ShopOption = ({ option, optionSubText, count = 0, selectOption }) => {
  const optionList = [OPTION.gummy, OPTION.capsule];

  return (
    <div class='shop-selector'>
      {count > 0 && <>
        <p class='shop-selector__header shop-selector__header--number'>{count}.</p> 
        <p class='shop-selector__header'>{count === 1 && 'Select'} Option</p>
      </>
      }
      <div class='shop-selector__input-box flex'>
        {optionList.map((val) => (
          <ShopOptionInput
            key={val}
            option={val}
            label={OPTION_DATA[val].label}
            subLabel={val === OPTION.capsule ? optionSubText[1] : optionSubText[0]}
            checked={option === val}
            onChange={() => selectOption(val)}
          />
        ))}
      </div>
    </div>
  );
};

export default ShopOption;
